import { render, staticRenderFns } from "./DashboardProductos.vue?vue&type=template&id=fc752f42&v-if=historial"
import script from "./DashboardProductos.vue?vue&type=script&lang=ts"
export * from "./DashboardProductos.vue?vue&type=script&lang=ts"
import style0 from "./DashboardProductos.vue?vue&type=style&index=0&id=fc752f42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports